import { authRoutes } from '@app/auth/auth-routes';
import { onboardingRoutes } from '@app/onboarding/onboarding-routes';
import Loader from '@shared/components/loader';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../auth/use-auth';

interface AuthenticatedRoutesProps {
  children?: React.ReactNode;
}

export const AuthenticatedRoutes = ({ children }: AuthenticatedRoutesProps) => {
  const { loadingAuth, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isOnSignupFlow =
    pathname === onboardingRoutes.SIGNUP_ABOUT_COMPANY ||
    pathname === onboardingRoutes.SIGNUP_COMPANY_AIMS ||
    pathname === onboardingRoutes.SIGNUP_CHECK_EMAIL;

  useEffect(() => {
    if (loadingAuth) return;

    if (!loadingAuth && !isAuthenticated) {
      navigate(authRoutes.LOGIN, {
        state: { from: location.pathname, search: location.search },
        replace: true,
      });
    }

    if (
      !user?.hasCompletedSignup &&
      isAuthenticated &&
      !loadingAuth &&
      !isOnSignupFlow
    ) {
      navigate(onboardingRoutes.SIGNUP_ABOUT_COMPANY);
    }
  }, [isAuthenticated, isOnSignupFlow, loadingAuth, navigate, pathname, user]);

  if (loadingAuth || !isAuthenticated)
    return <Loader className="h-screen" size="lg" withLogo />;

  return <>{children}</>;
};

export default AuthenticatedRoutes;
